module.exports = "pegasus/assets/theme3/small/5.jpg";